export const initExpandingColumnElement2 = () => {
    const items = document.querySelectorAll('.column-slider-item');
    let expandedItem = null;

    function handleItemInteraction() {
        if (expandedItem === this) return;

        items.forEach(item => {
            item.classList.remove('expanded');
        });

        this.classList.add('expanded');
        expandedItem = this;
    }

    function updateListeners() {
        const isWide = window.matchMedia("(min-width: 1150px)").matches;
        items.forEach(item => {
            item.removeEventListener('click', handleItemInteraction);
            item.removeEventListener('mouseover', handleItemInteraction);
            if (isWide) {
                item.addEventListener('click', handleItemInteraction);
                item.addEventListener('mouseover', handleItemInteraction);
            }
        });
    }

    updateListeners();

    let debounceTimer;
    function debounce(func, delay) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(func, delay);
    }

    window.addEventListener('resize', () => {
        debounce(updateListeners, 100);
    });
};
